export const VARIANCE_THRESHOLD_COOKIE_NAME = 'varianceThreshold';
export const DISPLAY_VARIANCE_THRESHOLD_COOKIE_NAME = 'displayVarianceThreshold';
export const VARIANCE_THRESHOLD_TYPE_COOKIE_NAME = 'varianceThresholdType';
export const VARIANCE_THRESHOLD_DISPLAY_FORMAT_COOKIE_NAME = 'varianceThresholdDisplayFormat';
export const SHOW_ONLY_EXCEEDING_ROWS_COOKIE_NAME = 'showOnlyExceedingRows';
export const CALCULATION_REPORT_LIST_NAME = 'calculationReportList';
export const OPENED_REPORTS_NAME = 'openedReports';
